export function hasLiveVersion(branches: readonly { name: string }[]): boolean {
  return branches.some((b) => b.name === "main");
}

export function branchLastActivity(branch: {
  lastChatEntryAt: number | null;
  lastRunAt: number | null;
  createdAt: number;
}): number {
  return Math.max(
    branch.lastChatEntryAt ?? 0,
    branch.lastRunAt ?? 0,
    branch.createdAt
  );
}

const DAY_MS = 24 * 60 * 60 * 1000;

// Branch tidy-up (versions dropdown, branch list) uses a short window; tidying
// a whole workflow away is more destructive, so it keeps a longer one.
export const BRANCH_INACTIVITY_DAYS = 7;
export const WORKFLOW_INACTIVITY_DAYS = 30;

type BranchActivity = {
  lastChatEntryAt: number | null;
  lastRunAt: number | null;
  createdAt: number;
};

export function isBranchStale(branch: BranchActivity): boolean {
  return (
    branchLastActivity(branch) < Date.now() - BRANCH_INACTIVITY_DAYS * DAY_MS
  );
}

export function isWorkflowStale(workflow: {
  branches: readonly BranchActivity[];
}): boolean {
  const cutoff = Date.now() - WORKFLOW_INACTIVITY_DAYS * DAY_MS;
  return workflow.branches.every((b) => branchLastActivity(b) < cutoff);
}
